import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {Subscription} from "rxjs";
import {map} from "rxjs/operators";
import {LfsaBotonEditarGridComponent} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {UsuarioBasculaGaritaService} from '../../services/usuario-bascula-garita.service';
import {MantenimientoBasculaService} from '../../services/mantenimiento-bascula.service';
import {MantenimientoGaritasService} from '../../services/mantenimiento-garitas.service';
import {IGaritaResponse} from '../../modelos/IMantGarita';
import {IMantBascula} from '../../modelos/IMantBascula';
import {UsuariosService} from '../../services/usuarios.service';
import {IUsuarioAll} from '../../modelos/IUsuario.js';

@Component({
  selector: 'app-usuario-bascula-garita',
  templateUrl: './usuario-bascula-garita.component.html',
  styleUrls: ['./usuario-bascula-garita.component.css']

})
export class UsuarioBasculaGaritaComponent implements OnInit {

  public DAT_TITULOS: any = moduloGaritas.titulos.mantUsuarioBasculaGarita;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_AG_GRID: any = moduloGaritas.agGrid;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public garitaSelect: IGaritaResponse[] = [];
  public basculaSelect: IMantBascula[] = [];

  public isCreate: boolean = false;
  public tituloModal: string = '';
  public loading: boolean = false;
  public showUsers: boolean = false;

  public agregarForm = new FormGroup({
    id: new FormControl(null),
    idusuario: new FormControl(null, [Validators.required]),
    usuarioDescripcion: new FormControl(null, [Validators.required]),
    cedula: new FormControl(null, [Validators.required]),
    garita: new FormControl(null, [Validators.required]),
    garitaDescripcion: new FormControl(null, [Validators.required]),
    bascula: new FormControl(null, [Validators.required]),
    basculaDescripcion: new FormControl(null, [Validators.required]),
    estadoGarita: new FormControl(null, [Validators.required]),
    estadoBascula: new FormControl(null, [Validators.required]),
    tipoBloqueo: new FormControl(null, []),
  });

  public cmbUsuarios: IUsuarioAll[] = [];
  private subscription = new Subscription();

  constructor(
    private _util: UtilsService,
    private usuarioBasculaGaritaS: UsuarioBasculaGaritaService,
    private basculaService: MantenimientoBasculaService,
    private garitasService: MantenimientoGaritasService,
    private usuariosService: UsuariosService
  ) {
  }

  ngOnInit() {
    this.girdComponent();
    this.obtenerTodo();

    this.subscription.add(
      this.agregarForm.get('garita').valueChanges.subscribe(
        resp => {
          if (resp) {
            let garita = this.garitaSelect.find(f => f.idGarita == resp);
            this.agregarForm.get('garitaDescripcion').setValue(`${garita.idGarita} - ${garita.desca}`);
            this.agregarForm.get('estadoGarita').setValue(0);
            this.agregarForm.get('estadoBascula').setValue(1);

            this.agregarForm.get('bascula').reset();
            this.agregarForm.get('basculaDescripcion').reset();

            this.agregarForm.get('bascula').removeValidators(Validators.required);
            this.agregarForm.get('bascula').updateValueAndValidity();
            this.agregarForm.get('basculaDescripcion').removeValidators(Validators.required);
            this.agregarForm.get('basculaDescripcion').updateValueAndValidity();
            this.agregarForm.get('basculaDescripcion').updateValueAndValidity();
          } else {
            this.agregarForm.get('garitaDescripcion').reset();
          }
        }
      )
    )

    this.subscription.add(
      this.agregarForm.get('bascula').valueChanges.subscribe(
        resp => {
          if (resp) {
            let bascula = this.basculaSelect.find(f => f.idBascula == resp);
            this.agregarForm.get('basculaDescripcion').setValue(`${bascula.idBascula} - ${bascula.desca}`);
            this.agregarForm.get('estadoBascula').setValue(0);
            this.agregarForm.get('estadoGarita').setValue(1);

            this.agregarForm.get('garita').reset();
            this.agregarForm.get('garitaDescripcion').reset();

            this.agregarForm.get('garita').removeValidators(Validators.required);
            this.agregarForm.get('garita').updateValueAndValidity();
            this.agregarForm.get('garitaDescripcion').removeValidators(Validators.required);
            this.agregarForm.get('garitaDescripcion').updateValueAndValidity();
          } else {
            this.agregarForm.get('basculaDescripcion').reset();
          }
        }
      )
    )
  }

  searchUser() {
    this.loading = true;
    this.subscription.add(
      this.usuariosService.obtenerPorId(this.agregarForm.get('idusuario').value).subscribe(
        resp => {
          if (resp) {
            this.loading = false;
            this.agregarForm.get('usuarioDescripcion').setValue(resp.login + ' - ' + resp.firstName);
            this.agregarForm.get('cedula').setValue(resp.login);
          } else {
            this.loading = false;
            this._util.mensajeErroToast('No se encontró el usuario.');
          }
        },
        error => {
          this.loading = false;
          this._util.mensajeErroToast('Ocurrió un error al buscar usuarios, inténtelo.');
        }
      )
    );
  }

  obtenerMantenimientoBascula() {
    this.basculaService.obtener()
      .pipe(map(m => m.filter(f => f.estado.toString() == 'ACTIVO')))
      .subscribe((resp) => {
        this.basculaSelect = resp;
        this.loading = false;
      },(error) => {
        //this.basculaSelect = [];
        this.loading = false;
      });
  }

  obtenerGaritas() {
    this.loading = true;
    this.garitasService.obtener()
      .pipe(
        map(m => m.filter(f => f.estado.toString() == 'ACTIVO'))
      )
      .subscribe(
        (resp) => {
          this.garitaSelect = resp;
          this.loading = false;
        },
        (error) => {
          this.garitaSelect = [];
          this.loading = false;
        }
      );
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Secuencial',
        field: 'id',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        headerName: 'Id Usuario',
        field: 'idusuario',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Cedula',
        field: 'cedula',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Garita',
        field: 'garitaDescripcion',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Báscula',
        field: 'basculaDescripcion',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Estado Garita',
        field: 'estadoGarita',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Estado Báscula',
        field: 'estadoBascula',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 80,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 80,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger,
        },
      }
    ];
  }

  searchUsers() {
    if (this.showUsers) {
      this.showUsers = false;
      this.cmbUsuarios = [];
      return;
    }
    this.loading = true;
    this.showUsers = false;
    this.agregarForm.get('usuarioDescripcion').disable({onlySelf: true});
    this.subscription.add(
      this.usuariosService.obtenerTodo().subscribe(
        resp => {
          this.agregarForm.get('usuarioDescripcion').reset();
          this.showUsers = true;
          this.loading = false;
          this.cmbUsuarios = resp;
          this.agregarForm.get('usuarioDescripcion').enable({onlySelf: false});
        },
        error => {
          this.showUsers = false;
          this.loading = false;
        }
      )
    );
  }

  selectedUser(cmb: IUsuarioAll) {
    this.showUsers = false;
    this.agregarForm.get('usuarioDescripcion').setValue(`${cmb.login} - ${cmb.nombre}`);
    this.agregarForm.get('usuarioDescripcion').disable({onlySelf: true});
    this.agregarForm.get('idusuario').setValue(`${cmb.login2}`);
  }

  obtenerTodo() {
    this.loading = true;
    this.rowData = [];

    this.usuarioBasculaGaritaS.obtener().subscribe((resp) => {
      this.rowData = resp;
      this.loading = false;
    },(error) => {
      this.loading = false;
      console.log(error.message); 
    });

    this.obtenerMantenimientoBascula();
    this.obtenerGaritas();
  }

  guardarCrearNueva() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();

    data.tipoBloqueo = data.tipoBloqueo == null || data.tipoBloqueo == "" ? "0" : data.tipoBloqueo;

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `Usuario: ${data.idusuario} ${data.bascula ? `- Báscula: ${data.bascula}` : ``} ${data.garita ? `- Garita: ${data.garita}` : ``}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.usuarioBasculaGaritaS.crear(data),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  guardarEditar() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();
    data.tipoBloqueo = data.tipoBloqueo == null || data.tipoBloqueo == "" ? "0" : data.tipoBloqueo;

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        text: `Usuario: ${data.idusuario} ${data.bascula ? `- Báscula: ${data.bascula}` : ``} ${data.garita ? `- Garita: ${data.garita}` : ``}`,
        action: this.DAT_BTNS.editar,
        funcion: this.usuarioBasculaGaritaS.editar(data),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  eliminar({rowData}) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        text: `Usuario: ${rowData.idusuario} ${rowData.bascula ? `- Báscula: ${rowData.bascula}` : ``} ${rowData.garita ? `- Garita: ${rowData.garita}` : ``}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.usuarioBasculaGaritaS.eliminar(rowData.id),
      })
      .then((res: any) => {
        this.obtenerTodo();
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  }

  nuevo() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.agregarForm.reset();
    this.agregarForm.get('tipoBloqueo').setValue('');

    this.agregarForm.get('usuarioDescripcion').disable({onlySelf: true});
    this.agregarForm.get('garitaDescripcion').disable({onlySelf: true});
    this.agregarForm.get('basculaDescripcion').disable({onlySelf: true});

    this.agregarForm.get('estadoGarita').setValue(0);
    this.agregarForm.get('estadoBascula').setValue(0);

    this.openModal();
  }

  editar({rowData}) {
    console.log("rowData", rowData)
    console.log("tipoBloqueo", rowData.tipoBloqueo)

    this.agregarForm.get('estadoGarita').setValue(0);
    this.agregarForm.get('estadoBascula').setValue(0);
    this.agregarForm.patchValue(rowData);

    if (rowData.tipoBloqueo == "DESBLOQUEO_PESO") this.agregarForm.get('tipoBloqueo').setValue(2);
    else if (rowData.tipoBloqueo == "DESBLOQUEO_CALIDAD") this.agregarForm.get('tipoBloqueo').setValue(1);
    else this.agregarForm.get('tipoBloqueo').setValue("NINGUNO");

    this.agregarForm.get('usuarioDescripcion').disable({onlySelf: true});
    this.agregarForm.get('garitaDescripcion').disable({onlySelf: true});
    this.agregarForm.get('basculaDescripcion').disable({onlySelf: true});

    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    this.openModal();
    this.searchUser();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNueva();
    if (!this.isCreate) this.guardarEditar();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
